import { DataTableSkeleton } from "../ui/DataTableSkeleton";
import { LoadingStatus, Skeleton, SkeletonText } from "../ui/Skeleton";

interface AgentDetailSkeletonProps {
  isProviderViewer?: boolean;
}

export function AgentDetailSkeleton({ isProviderViewer = false }: AgentDetailSkeletonProps) {
  const contractHeaders = isProviderViewer
    ? ["Carrier", "Status / Change", "Upline", "Notes", "Source", "Modified"]
    : ["Carrier", "Status / Change", "Upline", "Notes", "Source", "Modified", "User Actor", "Actions"];

  const contractCells = isProviderViewer
    ? (["text", "badge", "text", "text", "text", "text"] as const)
    : (["text", "badge", "text", "text", "text", "text", "text", "short"] as const);

  return (
    <section className="space-y-4" role="status" aria-busy="true">
      <LoadingStatus label="Loading agent detail" />

      <div className="mb-4 space-y-2">
        <div className="flex items-center gap-2">
          <SkeletonText width="w-14" className="h-3.5" />
          <SkeletonText width="w-3" className="h-3.5" />
          <SkeletonText width="w-28" className="h-3.5" />
        </div>
        <Skeleton className="h-8 w-56" />
        <SkeletonText width="w-40" className="h-3" />
      </div>

      <div className="space-y-3 rounded-[var(--card-radius)] border border-accent/20 bg-accent/5 p-4">
        <div className="flex items-center justify-between">
          <SkeletonText width="w-32" />
          <Skeleton className="h-5 w-24 rounded-full" />
        </div>
        <div className="grid gap-3 lg:grid-cols-2">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="flex gap-4">
              <SkeletonText width="w-24" className="shrink-0" />
              <SkeletonText />
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-3 rounded-[var(--card-radius)] border border-border-default bg-surface-raised p-4">
        <SkeletonText width="w-16" className="h-5" />
        <div className="flex gap-2">
          <Skeleton className="h-9 w-28 rounded-lg" />
          <Skeleton className="h-9 w-28 rounded-lg" />
        </div>
      </div>

      <DataTableSkeleton
        headers={contractHeaders}
        rows={5}
        cellVariants={[...contractCells]}
        loadingLabel="Loading provider contracts"
      />
    </section>
  );
}
